/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./push-name.vue?vue&type=template&id=0ba04757&scoped=true&"
import script from "./push-name.vue?vue&type=script&lang=ts&"
export * from "./push-name.vue?vue&type=script&lang=ts&"
import style0 from "./push-name.vue?vue&type=style&index=0&id=0ba04757&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba04757",
  null
  
)

export default component.exports